import { IDeductionDocumentSubTypeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetDocumentSubtypeUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IDeductionDocumentSubTypeRepositoryResponse> {
    return this.lookupRepository.getDocumentSubTypes();
  }
}